import { OpenRegular } from '@fluentui/react-icons';
import styled from 'styled-components';

export const TBody = styled.tbody``;

export const TableRow = styled.tr``;

export const TableBodyRow = styled(TableRow)`
  border-bottom: 2px solid ${(props) => props.theme.dividerMainColor};
  &.hoveredTaleRow {
    background: ${(props) => props.theme.tableRowHover};
  }
`;

export const TableBodyOpenIconCell = styled.td`
  color: ${(props) => props.theme.textMainColor};
  text-align: left;
  align-content: center;
  width: max-content;
`;

export const OpenIcon = styled(OpenRegular)`
  width: 24px;
  height: 24px;
  cursor: pointer;
  padding: 0px 2px;
  border-radius: 4px;
  border: 1px solid ${(props) => props.theme.calendarDividerColor};
  background: ${(props) => props.theme.mainBackgorund};
`;

export const EmptyHoveredPlaceholder = styled.div`
  width: 24px;
  height: 24px;
`;
